export const SET_INITIAL_CANDIDATES = 'SET_INITIAL_CANDIDATES';
export const SET_SEARCHED_CANDIDATES = 'SET_SEARCHED_CANDIDATES';
export const SET_MANAGER_AIN = 'SET_MANAGER_AIN';
export const SET_MANAGER_EMAIL = 'SET_MANAGER_EMAIL';
export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_SIDEBAR = 'SET_SIDEBAR';
